/* HMX GearWithLove Final Side Cart V17 — one scoped controller. */
(() => {
  'use strict';

  if (window.__HMX_CART_FINAL_V17__) return;
  window.__HMX_CART_FINAL_V17__ = true;

  const TITLE_PHONE_SUFFIX_RE = /\s+for\s+(?:(?:apple|samsung|google)\s+)?(?:iphone|galaxy|pixel)\b.*$/i;
  let frame = 0;
  let timer = 0;
  let observer = null;
  let observedDrawer = null;

  const compact = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const benefitIcon = (path) => `
    <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
      <path d="${path}"></path>
    </svg>`;

  const createBenefitBar = () => {
    const bar = document.createElement('div');
    bar.className = 'hmx-cart-v4__benefit-bar';
    bar.setAttribute('aria-label', 'Order benefits');
    bar.innerHTML = `
      <div class="hmx-cart-v4__benefit">
        ${benefitIcon('M12 2 3 6v6c0 5 3.4 9.7 9 11 5.6-1.3 9-6 9-11V6l-9-4Zm-1.1 14.3-4-4 1.4-1.4 2.6 2.6 5-5 1.4 1.4-6.4 6.4Z')}
        <span>50% OFF</span>
      </div>
      <div class="hmx-cart-v4__benefit">
        ${benefitIcon('M3 5h11v9h2.4l2.1-3H22v6h-2.1a3 3 0 0 1-5.8 0H9.9a3 3 0 0 1-5.8 0H2V7a2 2 0 0 1 1-2Zm1 2v8h.8a3 3 0 0 1 4.4 0H12V7H4Zm12 6v2h.1a3 3 0 0 1 3.8 0h.1v-2h-4Z')}
        <span>FREE SHIPPING</span>
      </div>
      <div class="hmx-cart-v4__benefit">
        ${benefitIcon('M12 3a9 9 0 1 0 8.5 6h-2.1A7 7 0 1 1 16.9 6L14 9h7V2l-2.7 2.7A9 9 0 0 0 12 3Zm-1 4h2v6h-2V7Zm0 8h2v2h-2v-2Z')}
        <span>30-DAY GUARANTEE</span>
      </div>`;
    return bar;
  };

  const parseMoney = (value) => {
    let text = String(value || '').replace(/\s+/g, '').replace(/[^0-9,.-]/g, '');
    if (!text) return 0;
    const negative = text.includes('-');
    text = text.replace(/-/g, '');
    const dot = text.lastIndexOf('.');
    const comma = text.lastIndexOf(',');
    let decimal = '';
    if (dot >= 0 && comma >= 0) decimal = dot > comma ? '.' : ',';
    else if (dot >= 0 && text.length - dot - 1 === 2) decimal = '.';
    else if (comma >= 0 && text.length - comma - 1 === 2) decimal = ',';

    let amount;
    if (decimal) {
      const index = text.lastIndexOf(decimal);
      const whole = text.slice(0, index).replace(/[.,]/g, '') || '0';
      const fraction = text.slice(index + 1).replace(/[.,]/g, '').padEnd(2, '0').slice(0, 2);
      amount = Number(`${whole}.${fraction}`);
    } else {
      amount = Number(text.replace(/[.,]/g, ''));
    }
    if (!Number.isFinite(amount)) return 0;
    return Math.round(amount * 100) * (negative ? -1 : 1);
  };

  const formatMoney = (cents) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (_) {}
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };

  const itemCount = (drawer) => {
    let count = 0;
    drawer.querySelectorAll('#CartDrawer .quantity__input').forEach((input) => {
      const value = Number.parseInt(input.value, 10);
      if (Number.isFinite(value) && value > 0) count += value;
    });
    return count;
  };

  const ensureHeader = (drawer) => {
    const inner = drawer.querySelector('#CartDrawer > .drawer__inner');
    const header = inner?.querySelector(':scope > .drawer__header');
    if (!inner || !header) return;

    let benefit = inner.querySelector(':scope > .hmx-cart-v4__benefit-bar');
    if (!benefit) {
      benefit = createBenefitBar();
      inner.insertBefore(benefit, header);
    }

    const heading = header.querySelector('.drawer__heading');
    if (heading) {
      const count = itemCount(drawer);
      const next = `<span>Your Bag</span><small>${count} ${count === 1 ? 'item' : 'items'}</small>`;
      if (heading.innerHTML.trim() !== next) heading.innerHTML = next;
    }

    header.querySelectorAll('.drawer__close').forEach((button) => {
      if (button.title !== 'Close cart') button.title = 'Close cart';
      if (!button.getAttribute('aria-label')) button.setAttribute('aria-label', 'Close cart');
    });
  };

  const buttonIntent = (button, index, buttons) => {
    const text = [
      button.getAttribute('name'),
      button.getAttribute('aria-label'),
      button.getAttribute('title'),
      button.dataset.action,
      button.className,
      button.textContent
    ].filter(Boolean).join(' ').toLowerCase();
    if (/plus|increase|increment|add/.test(text)) return 'plus';
    if (/minus|decrease|decrement|subtract/.test(text)) return 'minus';
    if (buttons.length === 2) return index === 1 ? 'plus' : 'minus';
    return '';
  };

  const normalizeQuantity = (controls) => {
    const input = controls.querySelector('quantity-input, .quantity, .cart-quantity');
    if (!input) return;

    const buttons = Array.from(input.querySelectorAll('button'));
    buttons.forEach((button, index) => {
      const intent = buttonIntent(button, index, buttons);
      if (!intent) return;
      button.setAttribute('name', intent);
      button.dataset.hmxQuantityIntent = intent;
      button.setAttribute('aria-label', intent === 'plus' ? 'Increase quantity' : 'Decrease quantity');
      button.querySelectorAll('svg').forEach((svg) => svg.remove());

      if (intent === 'plus') {
        const glyphs = Array.from(button.querySelectorAll(':scope > .hmx-quantity-plus-glyph'));
        let glyph = glyphs.shift();
        glyphs.forEach((duplicate) => duplicate.remove());
        if (!glyph) {
          glyph = document.createElement('span');
          glyph.className = 'hmx-quantity-plus-glyph';
          glyph.setAttribute('aria-hidden', 'true');
          button.appendChild(glyph);
        }
        if (glyph.textContent !== '+') glyph.textContent = '+';
      } else {
        button.querySelectorAll(':scope > .hmx-quantity-plus-glyph').forEach((glyph) => glyph.remove());
      }
    });
  };

  const cleanTitle = (item) => {
    const title = item.querySelector('.cart-item__name');
    if (!title) return;
    const current = compact(title.textContent);
    const original = title.dataset.hmxOriginalCartTitle || current;
    if (!title.dataset.hmxOriginalCartTitle) title.dataset.hmxOriginalCartTitle = original;
    const shortened = original.replace(TITLE_PHONE_SUFFIX_RE, '').trim();
    const next = shortened.length >= 16 ? shortened : original;
    if (compact(title.textContent) !== next) title.textContent = next;
    title.classList.add('hmx-cart-v14__clean-title');
    if (!title.getAttribute('title')) title.setAttribute('title', original);
  };

  const enhanceItem = (item) => {
    if (!(item instanceof Element)) return;
    const controls = item.querySelector('.cart-drawer-item__quantity-and-prices');
    if (!controls) return;

    controls.classList.add('hmx-cart-v4__item-controls', 'hmx-cart-v13__full-width-controls');
    if (controls.parentElement !== item) item.appendChild(controls);

    const remove = item.querySelector('.cart-drawer-item__cart-remove-button');
    if (remove && remove.parentElement !== controls) controls.insertBefore(remove, controls.firstChild);
    const removeButton = remove?.querySelector('button, .button');
    if (removeButton) {
      removeButton.title = 'Remove item';
      if (!removeButton.getAttribute('aria-label')) removeButton.setAttribute('aria-label', 'Remove item');
    }

    normalizeQuantity(controls);
    cleanTitle(item);
    item.classList.add('hmx-cart-v13__item-ready', 'hmx-cart-v14__item-ready', 'hmx-cart-v17__item-ready');
  };

  const renderedSavings = (drawer) => {
    const items = Array.from(drawer.querySelectorAll('#CartDrawer .cart-drawer-item'));
    let cents = 0;
    let currentPriceCount = 0;

    items.forEach((item) => {
      const totals = item.querySelector('.cart-item__totals');
      const current = totals?.querySelector('.regular-price, .cart-item__final-price, .price--end:not(.compare-price)');
      const compare = totals?.querySelector('.cart-item__old-price, .compare-price');
      if (current) currentPriceCount += 1;
      if (!current || !compare) return;
      cents += Math.max(0, parseMoney(compare.textContent) - parseMoney(current.textContent));
    });

    return { cents: Math.max(0, cents), itemCount: items.length, currentPriceCount };
  };

  const ensureSummary = (drawer) => {
    const totals = drawer.querySelector('#CartDrawer .drawer__footer .cart-drawer__totals');
    if (!totals) return;

    totals.querySelectorAll('.hmx-cart-shipping-row, .hmx-cart-dispatch').forEach((node) => node.remove());

    let shipping = totals.querySelector('.hmx-cart-v4__shipping-row');
    if (!shipping) {
      shipping = document.createElement('p');
      shipping.className = 'hmx-cart-v4__shipping-row';
      totals.appendChild(shipping);
    }
    const shippingMarkup = '<span>Shipping</span><strong>FREE</strong>';
    if (shipping.innerHTML !== shippingMarkup) shipping.innerHTML = shippingMarkup;

    let dispatch = totals.querySelector('.hmx-cart-v6__dispatch');
    if (!dispatch) {
      dispatch = document.createElement('p');
      dispatch.className = 'hmx-cart-v6__dispatch';
      shipping.insertAdjacentElement('afterend', dispatch);
    }
    if (dispatch.textContent !== 'Ships next business day') dispatch.textContent = 'Ships next business day';

    const result = renderedSavings(drawer);
    let savings = totals.querySelector('.hmx-cart-v7__savings');
    if (result.cents <= 0) {
      if (result.itemCount === 0 || result.currentPriceCount === result.itemCount) savings?.remove();
    } else {
      if (!savings) {
        savings = document.createElement('p');
        savings.className = 'hmx-cart-v7__savings hmx-cart-v14__savings';
        totals.insertBefore(savings, shipping);
      }
      const key = String(result.cents);
      if (savings.dataset.hmxSavingsCents !== key) {
        const formatted = formatMoney(result.cents);
        savings.innerHTML = `
          <span class="hmx-cart-v7__savings-label">
            <span class="hmx-cart-v7__savings-check" aria-hidden="true">✓</span>
            <span>You saved today</span>
          </span>
          <strong>${formatted}</strong>`;
        savings.dataset.hmxSavingsCents = key;
        savings.setAttribute('aria-label', `You saved ${formatted} today`);
      }
    }

    const checkout = drawer.querySelector('#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
    if (!checkout) return;
    const monies = drawer.querySelectorAll('.cart-drawer__totals__row__money, .totals__total-value');
    const total = monies.length ? compact(monies[monies.length - 1].textContent) : '';
    const labelText = total ? `Secure checkout • ${total}` : 'Secure checkout';
    const label = checkout.querySelector('.button__label');
    if (label) {
      if (compact(label.textContent) !== labelText) label.textContent = labelText;
    } else if (compact(checkout.textContent) !== labelText) {
      checkout.textContent = labelText;
    }
    checkout.setAttribute('aria-label', labelText);
  };

  const apply = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.add('hmx-cart-v4');
    drawer.querySelectorAll('#CartDrawer .cart-drawer-item').forEach(enhanceItem);
    ensureHeader(drawer);
    ensureSummary(drawer);
    drawer.dataset.hmxCartVersion = '17';
    attachObserver(drawer);
  };

  const schedule = (delay = 20) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(apply);
    }, delay);
  };

  const burst = () => [0, 60, 180, 400].forEach((delay) => window.setTimeout(apply, delay));

  function attachObserver(drawer) {
    if (observedDrawer === drawer && observer) return;
    observer?.disconnect();
    observedDrawer = drawer;
    observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) =>
        Array.from(mutation.addedNodes || []).some((node) =>
          node instanceof Element && (
            node.matches('#CartDrawer, .cart-drawer-item, .cart-drawer__totals, cart-drawer-items') ||
            node.querySelector?.('#CartDrawer, .cart-drawer-item, .cart-drawer__totals, cart-drawer-items')
          )
        )
      );
      if (relevant) schedule(15);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', burst, { once: true });
  } else {
    burst();
  }

  document.addEventListener('cart:updated', burst);
  document.addEventListener('cart-drawer:open', burst);
  document.addEventListener('shopify:section:load', burst);

  document.addEventListener('click', (event) => {
    if (event.target?.closest?.('#CartDrawer quantity-input button, #CartDrawer cart-remove-button, #CartDrawer .cart-drawer-item__cart-remove-button')) {
      burst();
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('#CartDrawer .quantity__input, #CartDrawer input[name="updates[]"]')) burst();
  });
})();
